<template>
<div class="kt-grid__item" :class="_class">
    <slot></slot>
</div>
</template>

<script>

export default {
    props: {
        grid_options: {
            type: Array,
            default: function() {
                return []
            },
        },
        options: {
            type: Array,
            default: function() {
                return []
            },
        },
        is_grid: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.is_grid === true) {
                _class.push('kt-grid')

                this.grid_options.forEach(function(option){
                    _class.push('kt-grid--'+option)
                })
            }

            this.options.forEach(function(option){
                _class.push('kt-grid__item--'+option)
            })
            
            return _class
        }
    }
}
</script>